import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getMarcas = async() => {
    const respuesta = await PrivateInterceptor(`IT/MarcaProducto/`, 'GET')
    return respuesta;
}

export const guardarMarca = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/MarcaProducto/AgregarMarca", "POST",{datos});
    return respuesta;
};
  
  export const editarMarca = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/MarcaProducto/EditarMarca", "POST",{datos});
    return respuesta;
};